import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import classnames from 'classnames'
import isFileSizeValid from '../../utils/is-file-size-valid'
import { attachFile } from '../../api-client/chat'
import Send from '../svg/send'
import FileSelector from './file-selector'

export default function Footer({
  onSend,
  conversationId,
  messages,
  onUploadProgressChange,
  onUploadSuccess,
  onUploadError,
  setSizeError,
}) {
  const [input, setInput] = useState('')
  const [error, setError] = useState(false)
  const { mutate } = useMutation(attachFile)

  const handleSubmit = (event) => {
    event.preventDefault()

    if (input.length > 0) {
      onSend({ message: input })
      setInput('')

      if (error) setError(false)
    } else {
      setError(true)
    }
  }

  const handleFileUpload = (file) => {
    if (isFileSizeValid({ file, maxSize: 5 })) {
      if (messages === null) {
        onSend(null, file)
      } else {
        mutate(
          { file, conversationId, xhrProgressCb: onUploadProgressChange },
          {
            onSuccess: (response) => {
              onSend({
                isFile: true,
                fileSize: response.size,
                fileType: file.type,
                message: response.url,
                key: response.key,
              })

              onUploadSuccess()
            },
            onError: onUploadError,
          },
        )
      }
    } else {
      setSizeError('Attachment size should be less than 5mb')
    }
  }

  return (
    <div className='flex alignCenter'>
      <form onSubmit={handleSubmit} className='flex'>
        <FileSelector onSelect={handleFileUpload} onError={(e) => alert(e)} />
        <input
          type='text'
          placeholder='Type message here'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          autoFocus
          className={classnames({ error })}
        />
        <button type='submit' className='flatBtn'>
          <Send fill='var(--primary-color)' />
        </button>
      </form>

      <style jsx>{`
        form {
          width: 100%;
        }

        input {
          width: 100%;
          margin: 0 0 0 1rem;
          border: none;
          line-height: 2.4rem;
          font-size: 1.8rem;
          outline: none;

          &.error::placeholder {
            color: var(--alert-color);
          }

          :placeholder {
            color: var(--secondary-text-color);
          }
        }
      `}</style>
    </div>
  )
}
